<template>
  <div class="site-setup-services-content">
    <Carousel3d
      v-if="servicesLoaded"
      :perspective="0"
      :space="500"
      :display="3"
      :controlsVisible="true"
      :height="450"
      :allowInnerClick="true"
      :min-swipe-distance="1000"
      :border="0"
      ref="servicesCarousel"
    >
      <Slide
        class="list-item-slide"
        :index="0"
        key="first-services-slide">
        <div class="centered">
          <h2>Add Some Services!</h2>
          <p>What are you offering to your customers? Add a few services to your services page.</p>
          <p>You can add more services or remove them later.</p>
          <p>Don't forget to click <strong>Update</strong> to save your changes before proceeding!</p>
          <br>
          <div class="btn-wrapper is-block">
            <button class="btn block is-pulsing is-tertiary" @click="goNext">Add Service</button>
          </div>
        </div>
      </Slide>

      <Slide
        v-for="(service, index) in services"
        class="list-item-slide"
        :index="index + 1"
        :key="`carousel-item-${index}`"
      >
        <EditServiceListItem
          :companyId="companyId"
          :siteId="siteId"
          :pageId="servicesPageId"
          :listId="servicesListId"
          :listItemId="service.id"
        />
      </Slide>
    </Carousel3d>
  </div>
</template>

<script>
import {readCompanySitePageListListItemsData} from '@/lib/list_items'

import EditServiceListItem from '@/components/SiteSetup/EditServiceListItem'
import Carousel3d from '@/components/Previewers/Carousel/Carousel3d'
import Slide from '@/components/Previewers/Carousel/Slide'

export default {
  name: 'services-content',

  data() {
    return {
      servicesLoaded: false,
      services: [],
      pageData: []
    }
  },

  props: {
    companyId: String,
    siteId: String,
    servicesListId: String,
    servicesPageId: String
  },

  components: {
    EditServiceListItem,
    Carousel3d,
    Slide
  },

  methods: {
    getServices() {
      readCompanySitePageListListItemsData(
        this.companyId,
        this.siteId,
        this.servicesPageId,
        this.servicesListId,
        {page: 1, page_size: 10}
      ).then(({data, page}) => {
        this.services = data
        this.pageData = page
        this.servicesLoaded = true
      })
    },

    goNext() {
      window.setTimeout(() => {
        this.$refs.servicesCarousel.goSlide(1)
      }, 250)
    }
  },

  mounted() {
    this.getServices()

    let text = `Tell your customers what it is you're offering by editing the services from above. You can skip this, if you like.`

    this.$emit(
      'setContinue',
      {
        name: 'reviewsContent'
      },
      text,
      `Updated a service? Remember to click the update button!`
    )
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/animations'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.site-setup-services-content
  margin: auto

  .list-item-slide
    padding: $gap-medium
    @extend %card
    position: absolute

    &.current
      transform: scale(0.9)!important

  .input
    margin: 0
</style>
